import React from 'react';

import { isNil, PartyTypes } from 'vdlib';
import InsuranceReports from 'containers/reports/InsuranceReportsContainer';
import MerchantReports from 'containers/reports/MerchantReportsContainer';
import AdminReports from 'containers/reports/AdminReportsContainer';

class MainReports extends React.Component {
  render() {
    if (isNil(this.props.partyType)) return false;

    let partyType = this.props.partyType.Description;
    return (
      <div>
        {partyType === PartyTypes.Insurance ? (
          <InsuranceReports />
        ) : partyType === PartyTypes.Merchant ? (
          <MerchantReports />
        ) : partyType === PartyTypes.Operator ||
          partyType === PartyTypes.Admin_Insurance ? (
          <AdminReports />
        ) : (
          'NO REPORTS'
        )}
      </div>
    );
  }
}

export default MainReports;
